import './index_web.css';
import { View, Image, Text } from '../../../component';
import Connection from '../../../utilities/Connection';
import useTheme from '../../../utilities/hooks/theme';
import { getPlayerName } from '../../../utilities/helper';
import I18n from '../../../utilities/locale';
import React from 'react';

interface Props {
  item: any;
  matchItem: any;
  onPressPlayer: any;
  lineupsOut?: boolean;
  keeperListDisable?: boolean;
  batsmanListDisable?: boolean;
  allRounderListDisable?: boolean;
  bowlerListDisable?: boolean;
  teamAPlayersCount?: number;
  teamBPlayersCount?: number;
  totalCreditCount?: any;
  substitutePlayers: any;
}
const CreateTeamPlayerRow = ({
  item = {},
  matchItem = {},
  onPressPlayer,
  lineupsOut = false,
  keeperListDisable = false,
  batsmanListDisable = false,
  allRounderListDisable = false,
  bowlerListDisable = false,
  teamAPlayersCount = 0,
  teamBPlayersCount = 0,
  totalCreditCount = 0,
  substitutePlayers = {}
}: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const {
    isSelected = 'false',
    teamId = '',
    shortName = '',
    role = '',
    rating = 0,
    playingEleven = false,
    id = '',
    playerId = ''
  } = item;
  const { teamA = {}, teamB = {} } = matchItem;
  const { teamId: teamAId = '' } = teamA;
  const { teamId: teamBId = '' } = teamB;
  const isTeamA = teamAId === teamId;
  const isTeamB = teamBId === teamId;
  const teamName = isTeamA ? teamA?.shortName : teamB?.shortName;
  const totalPlayerCount = teamAPlayersCount + teamBPlayersCount;
  let totalPoints = 0;
  const isSubstitutePlayer = substitutePlayers[id] === 1;
  const isDisable =
    (parseFloat(rating) > parseFloat(totalCreditCount) &&
      totalPlayerCount >= 10 &&
      isSelected === 'false') ||
    (totalPlayerCount === 11 && isSelected === 'false') ||
    (isTeamA && teamAPlayersCount >= 7) ||
    (isTeamB && teamBPlayersCount >= 7) ||
    (keeperListDisable && (role === 'wk' || role === 'wkbat')) ||
    (batsmanListDisable && role === 'bat') ||
    (allRounderListDisable && role === 'all') ||
    (bowlerListDisable && role === 'bowl');

  const disableRow = {
    backgroundColor: theme.createTeamDisableRow,
    opacity: 0.4
  };
  const defaultRow = {
    backgroundColor: theme.createTeamDefaultRow
  };
  const selectedRow = {
    backgroundColor: theme.createTeamSelectedRow
  };

  const playerNameText = {
    color:
      isDisable || isSubstitutePlayer
        ? theme.createTeamPlayerNameTextDisable
        : isSelected === 'true'
        ? theme.createTeamPlayerNameTextSelected
        : theme.createTeamPlayerNameTextDefault
  };

  const createTeamPointTextColor = {
    color:
      isDisable || isSubstitutePlayer
        ? theme.createTeamPointTextDisable
        : isSelected === 'true'
        ? theme.createTeamPointTextSelected
        : theme.createTeamPointTextDefault
  };

  const playerBorder =
    isSelected === 'false'
      ? theme.createTeamPlayerRowDefaultBorder
      : isTeamA
      ? theme.fantasyTeamAColor
      : theme.fantasyTeamBColor;
  const rowStyle =
    (isDisable && isSelected === 'false') || isSubstitutePlayer
      ? disableRow
      : isSelected === 'false'
      ? defaultRow
      : selectedRow;
  const selecttionBtnStyle = {
    backgroundColor:
      isSelected === 'false' ? theme.createTeamSelectBtnBg : theme.createTeamDeselectBtnBg
  };
  return (
    <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
      <View
        onPress={() => onPressPlayer(item)}
        // rippleColor={
        //   isSelected === 'false' ? theme.createTeamSelectedRow : theme.createTeamSelectedRow
        // }
        className={'create-team-player-row-wrapper'}
        style={{
          ...rowStyle,
          borderTopWidth: isSelected === 'false' ? '1.5px' : '1.5px',
          borderTopColor: playerBorder,
          borderBottomWidth: isSelected === 'false' ? '1.5px' : '1.5px',
          borderBottomColor: playerBorder,
          borderRightColor: isTeamA ? theme.fantasyTeamAColor : theme.fantasyTeamBColor,
          background: theme.createTeamPlayerRowBg
        }}
        disabled={isSubstitutePlayer || (isDisable && isSelected === 'false')}>
        <>
          <View
            className={'create-team-player-row-avatar'}
            style={{
              ...rowStyle,
              marginTop: isSelected === 'false' ? '-2px' : '-2px',
              marginBottom: isSelected === 'false' ? '-2px' : '-2px',
              borderColor: isTeamA ? theme.fantasyTeamAColor : theme.fantasyTeamBColor
            }}>
            <View className={'create-team-player-image-container'}>
              <Image
                source={`${Connection.getPlayerImageURL(playerId, '')}`}
                placeHolderType={'Player'}
                style={{
                  width: '100%',
                  height: '100%'
                }}
              />
            </View>
          </View>
          <View className={'create-team-player-row-container'}>
            <View className={'create-team-player-name-container'}>
              <Text className={'create-team-player-name-text'} style={playerNameText}>
                {getPlayerName(shortName)}
              </Text>
              {lineupsOut && (
                <View
                  className={'create-team-player-playing-container'}
                  style={{
                    borderColor: theme.createTeamPlayerPlayingBorder,
                    backgroundColor: theme.createTeamPlayerPlayingBG
                  }}>
                  <Text
                    className={'create-team-player-playing-label'}
                    style={{
                      color:
                        playingEleven && isSelected === 'true'
                          ? theme.createTeamPlayerPlaying
                          : playingEleven
                          ? theme.createTeamPlayerIsPlaying
                          : theme.createTeamPlayerIsNotPlaying
                    }}>
                    {playingEleven ? I18n.t('Playing') : I18n.t('NotPlaying')}
                  </Text>
                  <View
                    className={'create-team-player-dots '}
                    style={{
                      backgroundColor:
                        playingEleven && isSelected === 'true'
                          ? theme.createTeamPlayerPlaying
                          : playingEleven
                          ? theme.createTeamPlayerIsPlaying
                          : theme.createTeamPlayerIsNotPlaying
                    }}
                  />
                </View>
              )}
            </View>
            <View className={'create-team-player-col1 create-team-player-col1-center'}>
              <Text className={'create-team-player-count'} style={createTeamPointTextColor}>
                {totalPoints}
              </Text>
            </View>
            <View className={'create-team-player-col1 create-team-player-col1-center'}>
              <Text className={'create-team-player-count'} style={createTeamPointTextColor}>
                {rating}
              </Text>
            </View>
            {/* <View className={'create-team-player-add-remove-button'}>
              {isSelected === 'false' ? (
                <Constants.Svgs.TeamPlus width={'35px'} height={'35px'} />
              ) : (
                <Constants.Svgs.TeamMinus width={'35px'} height={'35px'} />
              )}
            </View> */}
          </View>
          <View
            className={'create-team-player-team-name-container'}
            style={{
              backgroundColor: isTeamA ? theme.fantasyTeamAColor : theme.fantasyTeamBColor
            }}>
            <Text
              className={'create-team-player-team-name'}
              style={{
                color: isTeamA ? '#000' : '#fff'
              }}>
              {teamName}
            </Text>
          </View>
        </>
      </View>
      <View
        className={'create-team-player-add-remove-button'}
        disabled={isSubstitutePlayer || (isDisable && isSelected === 'false')}>
        {isSelected === 'false' ? (
          <button
            className="add_remove_player_btn"
            style={selecttionBtnStyle}
            onClick={() => onPressPlayer(item)}>
            Select
          </button>
        ) : (
          <button
            className="add_remove_player_btn"
            style={selecttionBtnStyle}
            onClick={() => onPressPlayer(item)}>
            Deselect
          </button>
        )}
      </View>
    </div>
  );
};
export default React.memo(CreateTeamPlayerRow);
